export default __webpack_public_path__ + "static/media/hero-image.eb0d0567.png";